import { isEmpty, isObjectLike } from 'lodash';

import * as DataOrigins from 'commons-vehicle/constants/dataOrigins.js';
import {
    CAB_SIZE_DATA,
    CAB_SIZE_REGULAR,
    CAB_SIZE_EXTENDED,
    CAB_SIZE_CREW,
} from 'commons-vehicle/constants/dataConversions.js';
import {
    getDescriptionData,
    getModelTrimsBitField,
} from 'commons-vehicle/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js';
import CabSizeModel from 'commons-vehicle/ModelYear/models/CabSizeModel.js';
/* eslint import/prefer-default-export: 0 */

function resetCabSizeFromModelData(modelCabSizeData) {
    if (modelCabSizeData.length <= CAB_SIZE_DATA.CODE) {
        return new CabSizeModel();
    }

    const code = modelCabSizeData[CAB_SIZE_DATA.CODE];
    let rank;
    switch (code) {
        case CAB_SIZE_REGULAR:
            rank = 1;
            break;
        case CAB_SIZE_EXTENDED:
            rank = 2;
            break;
        case CAB_SIZE_CREW:
            rank = 3;
            break;
        default:
            rank = 4;
            break;
    }

    const { trimsBitField, trimsBitFields } = getModelTrimsBitField(modelCabSizeData[CAB_SIZE_DATA.BIT_FIELD]);

    return new CabSizeModel({
        trimsBitField,
        trimsBitFields,
        selectionCode: modelCabSizeData[CAB_SIZE_DATA.ID_CODE],
        code,
        rank,
        description: getDescriptionData(modelCabSizeData[CAB_SIZE_DATA.DESCRIPTION]),
    });
}

export function resetCabSizeFromOriginData(dataOrigin, originCabSizeData) {
    if (isEmpty(originCabSizeData) || !isObjectLike(originCabSizeData)) {
        return new CabSizeModel();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return new CabSizeModel();

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetCabSizeFromModelData(originCabSizeData);

        default:
            return new CabSizeModel();
    }
}

export default {
    resetCabSizeFromOriginData,
};
